var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"500px"}},[_c('example-description',{attrs:{"subject":"MpsDataTable 은 테마를 지원합니다.","content":"테마에 따라 다양한 스타일을 적용할 수 있습니다."}}),_c('v-btn',{on:{"click":_vm.onClickClear}},[_vm._v("초기화")]),_c('mps-data-table',{ref:"table",attrs:{"page":1,"count-per-page":5,"next":_vm.next,"headers":_vm.headers}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }